import React from 'react';
import {MagnifyingGlassIcon} from "@heroicons/react/20/solid";

interface SearchBarProps {
    onSearch: (query: string) => void;
    placeholder?: string;
    className?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, placeholder = "Rechercher...", className }) => (
    <div className={className}>
        <div className="grid grid-cols-1">
            <input
                type="text" name="project-name-search"
                placeholder={placeholder}
                className="col-start-1 row-start-1 block w-full border-0 rounded-md bg-white py-1.5 pl-3 pr-10 text-base text-gray-900 outline-solid outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-solid focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pr-9 sm:text-sm/6"
                onChange={(e) => onSearch(e.target.value)}
            />
            <MagnifyingGlassIcon
                aria-hidden="true"
                className="pointer-events-none col-start-1 row-start-1 mr-3 h-5 w-5 self-center justify-self-end text-gray-400"
            />
        </div>
    </div>
);

export default SearchBar;